import { render } from "./HelloWorld.vue?vue&type=template&id=85093098&scoped=true&ts=true"
import script from "./HelloWorld.vue?vue&type=script&lang=ts"
export * from "./HelloWorld.vue?vue&type=script&lang=ts"

import "./HelloWorld.vue?vue&type=style&index=0&id=85093098&scoped=true&lang=scss"

import exportComponent from "/Users/pradipdobariya/Documents/projects/DMA Global/caprock-merchant-old/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85093098"]])

export default __exports__